// src/auth/PhoneVerifiedRoute.js
import { useContext } from "react";
import { Navigate }   from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function PhoneVerifiedRoute({ children }) {
  const { token, needsPhoneVerification, isInitializing } = useContext(AuthContext);

  if (isInitializing) {
    return null; 
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (needsPhoneVerification) {
    return <Navigate to="/verify-phone" replace />;
  }

  return children;
}